import { render, staticRenderFns } from "./sliderImg.vue?vue&type=template&id=06da8376&scoped=true"
import script from "./sliderImg.vue?vue&type=script&lang=js"
export * from "./sliderImg.vue?vue&type=script&lang=js"
import style0 from "./sliderImg.vue?vue&type=style&index=0&id=06da8376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06da8376",
  null
  
)

export default component.exports